import React, { useState } from 'react';
import { Send, User, Bot, Paperclip, ArrowRight, Clock } from 'lucide-react';
const translations = {
  en: {
    title: 'AI Hiring Assistant',
    subtitle: 'Chat with our AI to get help with your hiring process',
    placeholder: 'Type your message here...',
    send: 'Send',
    uploadCV: 'Upload CV',
    startNew: 'Start New Chat',
    greeting: "Hello! I'm the Impresso AI Hiring Assistant. How can I help you today?",
    options: ['Tell me about open positions', 'How does the hiring process work?', 'Upload my CV', 'Schedule an interview'],
    responses: {
      positions: 'We have several open positions across engineering, marketing, and sales departments. What type of role are you looking for?',
      process: 'Our hiring process typically includes an initial application review, a screening call, 1-2 interviews, and a final decision. The whole process usually takes 2-3 weeks.',
      cv: "Great! I'd be happy to review your CV. Please upload it using the attachment button below.",
      interview: "I'd be happy to help schedule an interview. What days and times work best for you in the coming week?"
    },
    justNow: 'Just now',
    minutesAgo: 'minutes ago',
    hourAgo: 'hour ago',
    hoursAgo: 'hours ago',
    recentConversations: 'Recent conversations',
    hrPolicy: 'HR Policy Questions',
    jobApplication: 'Job Application Help',
    interviewPrep: 'Interview Preparation'
  },
  de: {
    title: 'KI-Einstellungsassistent',
    subtitle: 'Chatten Sie mit unserer KI, um Hilfe bei Ihrem Einstellungsprozess zu erhalten',
    placeholder: 'Geben Sie Ihre Nachricht hier ein...',
    send: 'Senden',
    uploadCV: 'Lebenslauf hochladen',
    startNew: 'Neuen Chat starten',
    greeting: 'Hallo! Ich bin der Impresso KI-Einstellungsassistent. Wie kann ich Ihnen heute helfen?',
    options: ['Informationen zu offenen Stellen', 'Wie funktioniert der Einstellungsprozess?', 'Meinen Lebenslauf hochladen', 'Ein Vorstellungsgespräch planen'],
    responses: {
      positions: 'Wir haben mehrere offene Stellen in den Bereichen Technik, Marketing und Vertrieb. Nach welcher Art von Position suchen Sie?',
      process: 'Unser Einstellungsprozess umfasst in der Regel eine erste Bewerbungsprüfung, ein Screening-Gespräch, 1-2 Interviews und eine endgültige Entscheidung. Der gesamte Prozess dauert normalerweise 2-3 Wochen.',
      cv: 'Großartig! Ich würde Ihren Lebenslauf gerne überprüfen. Bitte laden Sie ihn über die Anhangschaltfläche unten hoch.',
      interview: 'Ich helfe Ihnen gerne bei der Planung eines Interviews. Welche Tage und Zeiten passen Ihnen in der kommenden Woche am besten?'
    },
    justNow: 'Gerade eben',
    minutesAgo: 'Minuten zuvor',
    hourAgo: 'Stunde zuvor',
    hoursAgo: 'Stunden zuvor',
    recentConversations: 'Letzte Gespräche',
    hrPolicy: 'Fragen zur Personalpolitik',
    jobApplication: 'Hilfe bei der Bewerbung',
    interviewPrep: 'Interviewvorbereitung'
  },
  fr: {
    title: 'Assistant de recrutement IA',
    subtitle: "Discutez avec notre IA pour obtenir de l'aide avec votre processus de recrutement",
    placeholder: 'Tapez votre message ici...',
    send: 'Envoyer',
    uploadCV: 'Télécharger CV',
    startNew: 'Démarrer nouveau chat',
    greeting: "Bonjour! Je suis l'assistant de recrutement IA d'Impresso. Comment puis-je vous aider aujourd'hui?",
    options: ['Informations sur les postes ouverts', 'Comment fonctionne le processus de recrutement?', 'Télécharger mon CV', 'Planifier un entretien'],
    responses: {
      positions: "Nous avons plusieurs postes ouverts dans les départements d'ingénierie, de marketing et de ventes. Quel type de poste recherchez-vous?",
      process: "Notre processus de recrutement comprend généralement une première revue de candidature, un appel de présélection, 1-2 entretiens et une décision finale. L'ensemble du processus prend généralement 2-3 semaines.",
      cv: "Parfait! Je serais ravi d'examiner votre CV. Veuillez le télécharger en utilisant le bouton de pièce jointe ci-dessous.",
      interview: 'Je serais heureux de vous aider à planifier un entretien. Quels jours et horaires vous conviennent le mieux dans la semaine à venir?'
    },
    justNow: "À l'instant",
    minutesAgo: 'minutes',
    hourAgo: 'heure',
    hoursAgo: 'heures',
    recentConversations: 'Conversations récentes',
    hrPolicy: 'Questions sur la politique RH',
    jobApplication: "Aide à la candidature d'emploi",
    interviewPrep: "Préparation d'entretien"
  },
  it: {
    title: 'Assistente di assunzione AI',
    subtitle: 'Chatta con la nostra AI per ricevere aiuto con il tuo processo di assunzione',
    placeholder: 'Scrivi il tuo messaggio qui...',
    send: 'Invia',
    uploadCV: 'Carica CV',
    startNew: 'Inizia nuova chat',
    greeting: "Ciao! Sono l'assistente di assunzione AI di Impresso. Come posso aiutarti oggi?",
    options: ['Informazioni sulle posizioni aperte', 'Come funziona il processo di assunzione?', 'Carica il mio CV', 'Programma un colloquio'],
    responses: {
      positions: 'Abbiamo diverse posizioni aperte nei dipartimenti di ingegneria, marketing e vendite. Che tipo di ruolo stai cercando?',
      process: "Il nostro processo di assunzione include tipicamente una revisione iniziale della candidatura, una chiamata di screening, 1-2 colloqui e una decisione finale. L'intero processo dura solitamente 2-3 settimane.",
      cv: 'Ottimo! Sarei felice di esaminare il tuo CV. Caricalo utilizzando il pulsante allegato qui sotto.',
      interview: 'Sarei felice di aiutarti a programmare un colloquio. Quali giorni e orari ti vanno meglio nella prossima settimana?'
    },
    justNow: 'Proprio ora',
    minutesAgo: 'minuti fa',
    hourAgo: 'ora fa',
    hoursAgo: 'ore fa',
    recentConversations: 'Conversazioni recenti',
    hrPolicy: 'Domande sulla politica HR',
    jobApplication: 'Aiuto per la candidatura',
    interviewPrep: 'Preparazione al colloquio'
  }
};
// Sample conversations for demo purposes
const sampleConversations = {
  hrPolicy: [{
    type: 'user',
    text: 'What is the company policy on remote work?',
    timestamp: new Date(Date.now() - 1000 * 60 * 5) // 5 minutes ago
  }, {
    type: 'bot',
    text: 'Our company has a flexible remote work policy. Employees can work remotely up to 3 days per week, with the specific days arranged with their team manager. Some roles may be eligible for full remote work depending on the position and department needs. Would you like more details about any specific aspect of our remote work policy?',
    timestamp: new Date(Date.now() - 1000 * 60 * 4) // 4 minutes ago
  }, {
    type: 'user',
    text: 'What about vacation time and paid time off?',
    timestamp: new Date(Date.now() - 1000 * 60 * 3) // 3 minutes ago
  }, {
    type: 'bot',
    text: 'Our company offers a competitive PTO package. Full-time employees receive 20 days of paid vacation annually, plus 10 paid holidays and 5 sick days. Vacation accrues from your start date, and unused vacation can be carried over to the following year (up to 5 days). Senior employees with 5+ years at the company receive an additional 5 vacation days. Would you like information about parental leave or other time-off policies?',
    timestamp: new Date(Date.now() - 1000 * 60 * 2) // 2 minutes ago
  }],
  jobApplication: [{
    type: 'user',
    text: 'I want to apply for the Software Engineer position. What qualifications are required?',
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 2) // 2 hours ago
  }, {
    type: 'bot',
    text: "For the Software Engineer position, we require a Bachelor's degree in Computer Science or related field, 3+ years of experience with modern web technologies, proficiency in JavaScript/TypeScript and React, experience with backend technologies like Node.js, and strong problem-solving skills. Experience with cloud platforms (AWS/Azure) is a plus. Would you like me to help you with the application process?",
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 2 + 1000 * 60) // 1 minute after previous message
  }],
  interviewPrep: [{
    type: 'user',
    text: 'I have an interview next week. What should I prepare?',
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24) // 1 day ago
  }, {
    type: 'bot',
    text: "Great! For your upcoming interview, I recommend: 1) Research our company, mission, and recent news, 2) Review the job description and prepare examples that demonstrate relevant skills, 3) Prepare questions to ask the interviewer, 4) Practice common interview questions, especially behavioral ones using the STAR method, 5) Plan your outfit and test your tech setup if it's a virtual interview. Would you like sample questions to practice with?",
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24 + 1000 * 60) // 1 minute after previous message
  }]
};
export function ChatInterface({
  language
}) {
  const t = translations[language];
  const [input, setInput] = useState('');
  const [messages, setMessages] = useState([{
    type: 'bot',
    text: t.greeting,
    options: t.options,
    timestamp: new Date()
  }]);
  const [activeConversation, setActiveConversation] = useState('new');
  const handleSend = () => {
    if (input.trim() === '') return;
    // Add user message
    const userMessage = {
      type: 'user',
      text: input,
      timestamp: new Date()
    };
    setMessages([...messages, userMessage]);
    // Simulate bot response
    setTimeout(() => {
      let response = 'I understand. Let me help you with that.';
      // Simple keyword matching for demo purposes
      if (input.toLowerCase().includes('position') || input.toLowerCase().includes('job')) {
        response = t.responses.positions;
      } else if (input.toLowerCase().includes('process') || input.toLowerCase().includes('how')) {
        response = t.responses.process;
      } else if (input.toLowerCase().includes('cv') || input.toLowerCase().includes('resume')) {
        response = t.responses.cv;
      } else if (input.toLowerCase().includes('interview') || input.toLowerCase().includes('schedule')) {
        response = t.responses.interview;
      } else if (input.toLowerCase().includes('remote') || input.toLowerCase().includes('work from home')) {
        response = 'Our company has a flexible remote work policy. Employees can work remotely up to 3 days per week, with the specific days arranged with their team manager. Some roles may be eligible for full remote work depending on the position and department needs.';
      } else if (input.toLowerCase().includes('vacation') || input.toLowerCase().includes('time off') || input.toLowerCase().includes('pto')) {
        response = 'Our company offers a competitive PTO package. Full-time employees receive 20 days of paid vacation annually, plus 10 paid holidays and 5 sick days. Vacation accrues from your start date, and unused vacation can be carried over to the following year (up to 5 days).';
      } else if (input.toLowerCase().includes('benefits') || input.toLowerCase().includes('health') || input.toLowerCase().includes('insurance')) {
        response = 'We offer comprehensive benefits including health, dental, and vision insurance that begins on your first day. We also provide a 401(k) plan with company matching, life insurance, disability coverage, and a wellness program with gym reimbursement.';
      } else if (input.toLowerCase().includes('parental') || input.toLowerCase().includes('maternity') || input.toLowerCase().includes('paternity')) {
        response = 'Our parental leave policy provides 12 weeks of paid leave for primary caregivers and 4 weeks for secondary caregivers. This applies to births, adoptions, and foster placements. We also offer flexible return-to-work arrangements to help new parents transition back.';
      }
      const botMessage = {
        type: 'bot',
        text: response,
        timestamp: new Date()
      };
      setMessages(prev => [...prev, botMessage]);
    }, 1000);
    setInput('');
  };
  const handleOptionClick = option => {
    // Add user message
    const userMessage = {
      type: 'user',
      text: option,
      timestamp: new Date()
    };
    setMessages([...messages, userMessage]);
    // Simulate bot response
    setTimeout(() => {
      let response = 'I understand. Let me help you with that.';
      if (option === t.options[0]) {
        response = t.responses.positions;
      } else if (option === t.options[1]) {
        response = t.responses.process;
      } else if (option === t.options[2]) {
        response = t.responses.cv;
      } else if (option === t.options[3]) {
        response = t.responses.interview;
      }
      const botMessage = {
        type: 'bot',
        text: response,
        timestamp: new Date()
      };
      setMessages(prev => [...prev, botMessage]);
    }, 1000);
  };
  const handleKeyDown = e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };
  const startNewChat = () => {
    setActiveConversation('new');
    setMessages([{
      type: 'bot',
      text: t.greeting,
      options: t.options,
      timestamp: new Date()
    }]);
  };
  const loadConversation = conversationType => {
    setActiveConversation(conversationType);
    if (conversationType === 'new') {
      startNewChat();
      return;
    }
    // Load sample conversation
    if (sampleConversations[conversationType]) {
      setMessages(sampleConversations[conversationType]);
    }
  };
  const formatTimestamp = timestamp => {
    if (!timestamp) return '';
    const now = new Date();
    const diff = Math.floor((now - timestamp) / 1000 / 60); // difference in minutes
    if (diff < 1) return t.justNow;
    if (diff < 60) return `${diff} ${t.minutesAgo}`;
    if (diff < 120) return `1 ${t.hourAgo}`;
    return `${Math.floor(diff / 60)} ${t.hoursAgo}`;
  };
  return <div className="container mx-auto px-4 py-6 max-w-4xl" data-id="element-146">
      <div className="bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-147">
        <div className="bg-blue-600 text-white p-4" data-id="element-148">
          <h2 className="text-xl font-bold" data-id="element-149">{t.title}</h2>
          <p className="text-sm opacity-80" data-id="element-150">{t.subtitle}</p>
        </div>
        <div className="flex h-[500px] md:h-[600px]" data-id="element-151">
          {/* Sidebar */}
          <div className="hidden md:block w-64 bg-gray-50 border-r border-gray-200" data-id="element-152">
            <div className="p-4" data-id="element-153">
              <button onClick={startNewChat} className="w-full flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-md transition-colors" data-id="element-154">
                <ArrowRight size={16} data-id="element-155" />
                {t.startNew}
              </button>
            </div>
            <div className="px-4 py-2 text-sm text-gray-500" data-id="element-156">
              {t.recentConversations}
            </div>
            <div className="border-t border-gray-200" data-id="element-157">
              {/* Clickable conversation history */}
              <div className={`p-3 hover:bg-gray-100 cursor-pointer border-b border-gray-200 ${activeConversation === 'hrPolicy' ? 'bg-blue-50' : ''}`} onClick={() => loadConversation('hrPolicy')} data-id="element-158">
                <div className="text-sm font-medium" data-id="element-159">{t.hrPolicy}</div>
                <div className="text-xs text-gray-500 truncate" data-id="element-160">
                  5 minutes ago
                </div>
              </div>
              <div className={`p-3 hover:bg-gray-100 cursor-pointer border-b border-gray-200 ${activeConversation === 'jobApplication' ? 'bg-blue-50' : ''}`} onClick={() => loadConversation('jobApplication')} data-id="element-161">
                <div className="text-sm font-medium" data-id="element-162">{t.jobApplication}</div>
                <div className="text-xs text-gray-500 truncate" data-id="element-163">
                  2 hours ago
                </div>
              </div>
              <div className={`p-3 hover:bg-gray-100 cursor-pointer border-b border-gray-200 ${activeConversation === 'interviewPrep' ? 'bg-blue-50' : ''}`} onClick={() => loadConversation('interviewPrep')} data-id="element-164">
                <div className="text-sm font-medium" data-id="element-165">{t.interviewPrep}</div>
                <div className="text-xs text-gray-500 truncate" data-id="element-166">Yesterday</div>
              </div>
            </div>
          </div>
          {/* Chat Area */}
          <div className="flex-1 flex flex-col" data-id="element-167">
            {/* Messages */}
            <div className="flex-1 overflow-y-auto p-4 space-y-6" data-id="element-168">
              {messages.map((message, index) => {
              // Check if this is the first message or if the previous message was from a different sender
              const isNewGroup = index === 0 || messages[index - 1].type !== message.type;
              return <div key={index} className={`${isNewGroup ? 'mt-6' : 'mt-2'} ${message.type === 'user' ? 'flex justify-end' : 'flex justify-start'}`} data-id="element-169">
                    <div className={`flex max-w-[80%] ${message.type === 'user' ? 'flex-row-reverse' : 'flex-row'}`} data-id="element-170">
                      {/* Only show the avatar for the first message in a group */}
                      {isNewGroup && <div className={`flex-shrink-0 h-8 w-8 rounded-full flex items-center justify-center ${message.type === 'user' ? 'bg-blue-100 ml-2' : 'bg-gray-200 mr-2'}`} data-id="element-171">
                          {message.type === 'user' ? <User size={16} className="text-blue-600" data-id="element-172" /> : <Bot size={16} className="text-gray-600" data-id="element-173" />}
                        </div>}
                      <div className={`flex flex-col ${message.type === 'user' ? 'items-end' : 'items-start'}`} data-id="element-174">
                        <div className={`py-3 px-4 rounded-lg ${message.type === 'user' ? 'bg-blue-600 text-white rounded-tr-none' : 'bg-gray-100 text-gray-800 rounded-tl-none'} shadow-sm`} data-id="element-175">
                          <p className="text-sm leading-relaxed" data-id="element-176">
                            {message.text}
                          </p>
                          {/* Quick reply options */}
                          {message.options && <div className="mt-3 flex flex-wrap gap-2" data-id="element-177">
                              {message.options.map((option, i) => <button key={i} onClick={() => handleOptionClick(option)} className="text-xs bg-white text-blue-600 border border-blue-200 rounded-full py-1 px-3 hover:bg-blue-50 transition-colors" data-id="element-178">
                                  {option}
                                </button>)}
                            </div>}
                        </div>
                        {/* Timestamp */}
                        <div className={`text-xs text-gray-400 mt-1 flex items-center ${message.type === 'user' ? 'justify-end' : 'justify-start'}`} data-id="element-179">
                          <Clock size={10} className="mr-1" data-id="element-180" />
                          {formatTimestamp(message.timestamp)}
                        </div>
                      </div>
                    </div>
                  </div>;
            })}
            </div>
            {/* Input */}
            <div className="border-t border-gray-200 p-4 bg-gray-50" data-id="element-181">
              <div className="flex items-center gap-2" data-id="element-182">
                <button className="text-gray-500 hover:text-blue-600 p-2 rounded-full hover:bg-gray-100" data-id="element-183">
                  <Paperclip size={20} data-id="element-184" />
                </button>
                <div className="flex-1 relative" data-id="element-185">
                  <input type="text" value={input} onChange={e => setInput(e.target.value)} onKeyDown={handleKeyDown} placeholder={t.placeholder} className="w-full border border-gray-300 rounded-full py-3 px-4 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent shadow-sm" data-id="element-186" />
                </div>
                <button onClick={handleSend} disabled={input.trim() === ''} className={`rounded-full p-3 ${input.trim() === '' ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'bg-blue-600 text-white hover:bg-blue-700 shadow-sm'}`} data-id="element-187">
                  <Send size={20} data-id="element-188" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}